import swal from 'sweetalert2'
const moment = require("moment");
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'

import cSwitch from '../../../components/Switch';
import UserSearchModal from './UserSearchModal';
import { EventBus } from "../../event-bus";

export default {
    name: "userCompanyDetail",
    props: {
        userId: {
            type: String,
            default: ""
        },
        // 기업회원관리를 통한 상세 화면
        companyFlag: {
            type: String,
            default: ""
        }
    },
    created() {
        // 이벤트 버스 선언
        EventBus.$on('callUserSearchCloseModal', () => {
            this.closeUserSearchModal();
        });
    },
    data() {
        return {
            datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
            formModal: false,
            item: {},
            modifyItem: {
                user_id: '',
                p_type: '',
                p_code: '',
                auth_download_type: '',
                period_code: '',
                auth_start_date_tmp: null,
                auth_end_date_tmp: null,
                auth_start_date: '',
                auth_end_date: '',
                price: 0,
                dc_price: 0,
                amount: 0,

                orderer_company_name: '',
                orderer_department: '',
                orderer_name: '',
                orderer_level: '',
                orderer_email: '',
                orderer_mobile: '',
                bl_number: '',
                orderer_phone: '',
                tax_yn: '',
                tax_hope_date_tmp: null,
                tax_hope_date: '',
                tax_email: '',
                tax_name: '',
                tax_tel: '',
                dmc_manager_name: '',
                dmc_manager_dept: '',
                dmc_manager_memo: '',
            },
            isModify: false,
            isModifyLoading: false,
            pTypeList: [],
            pPeriodList: [],
            pDownloadTypeList: [],
            queryParams: {
                fix_yn: 'Y',
            },
            productCompanyList: [],

        }
    },
    watch: {
        userId: function (value, oldValue) {
            this.findCompanyInfo();
            this.findCodesList();
            this.findDrProductCompanyList();
        },
        'modifyItem.price': function (value, oldValue) {
            // console.log('price', value, oldValue)
            this.modifyItem.price = value.replace(/[^0-9]/g,'');
        },
        'modifyItem.dc_price': function (value, oldValue) {
            this.modifyItem.dc_price = value.replace(/[^0-9]/g,'');
        },
        companyFlag: function (value, oldValue) {
            // 등록 화면 일때...
            if(value !=null && value === 'R'){
                this.isModify = true;
                this.findCodesList();
                this.findDrProductCompanyList();
            }
        },
    },
    methods: {
        openUserSearchModal() {
            this.formModal = true;
        },
        closeUserSearchModal() {
            this.formModal = false;
        },
        // 기업 상품 목록
        findDrProductCompanyList() {
            var token = sessionStorage.getItem("myToken");

            var param = encodeURI(JSON.stringify(this.queryParams));
            var reqData = new FormData();
            reqData.append('objs', param);

            this.$http.post('/api/select/drProductAuthList?access_token=' + token, reqData, null)
            .then((result) => {
                const { data } = result;
                // console.log('findDrProductCompanyList', data);
                this.productCompanyList = data;

                // companyFlag R 등록 화면용
                if(this.companyFlag === 'R') this.modifyItem.p_code = this.productCompanyList[0].p_code;
            })
        },
        findCompanyInfo() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/userCompanyData?access_token='+token + '&user_id=' + this.userId)
                .then((result) => {
                    const { data } = result;
                    // console.log('>>>>>', data);
                    this.item = data;

                    const { auth_start_date, auth_end_date, tax_hope_date } = this.item;

                    this.item.auth_start_date_tmp = moment(auth_start_date, 'YYYY-MM-DD').toDate();
                    this.item.auth_end_date_tmp = moment(auth_end_date, 'YYYY-MM-DD').toDate();
                    this.item.tax_hope_date_tmp = (tax_hope_date !== null && tax_hope_date !== '') ? moment(tax_hope_date, 'YYYY-MM-DD').toDate() : '';

                    this.modifyItem = _.cloneDeep(data);

                    this.modifyItem.orderer_company_name = (this.modifyItem.orderer_company_name !== null && this.modifyItem.orderer_company_name !== '') ? this.modifyItem.orderer_company_name : this.modifyItem.user_company_name;
                    this.modifyItem.orderer_email = (this.modifyItem.orderer_company_name !== null && this.modifyItem.orderer_company_name !== '') ? this.modifyItem.orderer_company_name : this.modifyItem.user_id;
                    this.modifyItem.orderer_mobile = (this.modifyItem.orderer_mobile !== null && this.modifyItem.orderer_mobile !== '') ? this.modifyItem.orderer_mobile : this.modifyItem.mobile;
                    this.modifyItem.orderer_phone = (this.modifyItem.orderer_phone !== null && this.modifyItem.orderer_phone !== '') ? this.modifyItem.orderer_phone : this.modifyItem.phone;
                    this.modifyItem.orderer_name = (this.modifyItem.orderer_name !== null && this.modifyItem.orderer_name !== '') ? this.modifyItem.orderer_name : this.modifyItem.user_name;
            })
        },
        findCodesList() {
            var token = sessionStorage.getItem("myToken");
            // PRDT_TYPE(상품구분) > PRDT_TYPE_2(계정상품) > 코드 목록
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=PRDT_TYPE_2')
            .then((result) => {
                    const { data } = result;
                    // console.log('PRDT_TYPE_2', data);
                    this.pTypeList = data;

                    // companyFlag R 등록 화면용
                    if(this.companyFlag === 'R') this.modifyItem.p_type = this.pTypeList[0].item_code;
            })
            // PRDT_PERIOD(상품기간) > 코드 목록
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=PRDT_PERIOD')
            .then((result) => {
                    const { data } = result;
                    // console.log('PRDT_PERIOD', data);
                    this.pPeriodList = data;

                    // companyFlag R 등록 화면용
                    if(this.companyFlag === 'R') {
                        this.modifyItem.period_code = this.pPeriodList[0].item_code;
                        this.fnSetAuthDate('');
                    }
            })
            // AUTH_DOWNLOAD_TYPE(계정권한 다운로드 형식) > 코드목록
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=AUTH_DOWNLOAD_TYPE')
            .then((result) => {
                    const { data } = result;
                    // console.log('AUTH_DOWNLOAD_TYPE', data);
                    this.pDownloadTypeList = data;

                    // companyFlag R 등록 화면용
                    if(this.companyFlag === 'R') this.modifyItem.auth_download_type = this.pDownloadTypeList[0].item_code;
            })

        },
        // 등록화면용 기본 일자 세팅
        fnSetAuthDate(term) {
            const nowDate = new Date();
            this.modifyItem.auth_start_date_tmp = moment(nowDate).toDate();
            if(term === '' || term === 'PRDT_PERIOD_1'){
                this.modifyItem.auth_end_date_tmp = moment(nowDate).toDate();
            }else {
                // this.sortedPPeriodList
                const period = _.find(this.sortedPPeriodList, (o) => o.item_code === term);
                // 값만 있는 개월
                this.modifyItem.auth_end_date_tmp = moment(nowDate).add(period.item_name, 'M').toDate();
            }
        },
        // 만료기능
        fnAuthStateExpire() {
            swal.fire({
                title: '구독회원 만료!',
                text: "해당 사용자를 만료처리 하시겠습니까?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK'
              }).then((swalResult) => {
                if (swalResult.value) {
                    var token = sessionStorage.getItem("myToken");

                    var param = encodeURI(JSON.stringify(this.modifyItem));
                    var data = new FormData();
                    data.append('order', param);

                    this.$http.post('/api/update/expireCompanyOrder?access_token='+token, data, null)
                        .then((result) => {
                            const { data } = result;
                            if(data === 'ok'){
                                this.item = {}
                                this.modifyItem = {}

                                this.findCompanyInfo();
                                this.isModify = false;
                            }else{
                                swal.fire({
                                    type: 'error',
                                    title: '수정 중 오류가 발생하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            }
                    });
                }
              })
        },
        slotPTypeChange(event) {
            // console.log('slotPTypeChange', event.target.value);
            this.modifyItem.p_type = event.target.value;
        },
        slotDownloadTypeChange(event) {
            this.modifyItem.auth_download_type = event.target.value;
            // 서비스 제공기간, 사용권한 변경시 서비스 이용금액 변경
            this.fnGetAmout();
        },
        slotPeriodTypeChange(event) {
            this.modifyItem.period_code = event.target.value;

            // 등록화면용
            if(this.companyFlag === 'R') this.fnSetAuthDate(event.target.value);

            // 서비스 제공기간, 사용권한 변경시 서비스 이용금액 변경
            this.fnGetAmout();
        },
        // 서비스 제공기간, 사용권한 변경시 고정 기업 상품의 가격 가져오기
        fnGetAmout() {
            // console.log('modifyItem', this.modifyItem);
            this.productCompanyList.forEach(data => {
                // console.log(data);
                const { p_code, auth_download_type, period_code, price } = data;
                if(auth_download_type === this.modifyItem.auth_download_type && period_code === this.modifyItem.period_code){
                    // console.log('!!', p_code, auth_download_type, period_code, price);
                    this.modifyItem.price = price;
                    this.modifyItem.p_code = p_code;
                }
            });
        },
        fnModify() {
            this.isModify = true;
        },
        fnModifyCancel(){
            this.isModify = false;
        },
        isRangeDateCheck(){
            // console.log(this.modifyItem.auth_start_date, this.modifyItem.auth_end_date);
            if(this.modifyItem.auth_start_date_tmp > this.modifyItem.auth_end_date_tmp){
                swal.fire({
                    text: "이용기간 시작일이 종료일보다 큽니다.",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {

                    }
                  })
                // 이전 데이터로 초기화
                this.modifyItem.auth_start_date_tmp = moment(this.item.auth_start_date, 'YYYY-MM-DD').toDate();
                this.modifyItem.auth_end_date_tmp = moment(this.item.auth_end_date, 'YYYY-MM-DD').toDate();
            }else{

            }
        },
        fnSaveProcess(type) {
            // 최종 결제금액 마이너스 확인
            if(this.modifyItem.price - this.modifyItem.dc_price < 0){
                swal.fire({
                    text: "최종 결제금액이 0원 미만입니다.",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {}
                  })
            }else if(this.modifyItem.user_id === null || this.modifyItem.user_id === ''){
                swal.fire({
                    text: "신청자 정보를 선택하여 주세요.",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {}
                  })
            }else{
                this.isModifyLoading = true;
                this.modifyItem.auth_start_date = moment(this.modifyItem.auth_start_date_tmp).format('YYYY-MM-DD');
                this.modifyItem.auth_end_date = moment(this.modifyItem.auth_end_date_tmp).format('YYYY-MM-DD');
                this.modifyItem.tax_hope_date = (this.modifyItem.tax_hope_date_tmp === null || this.modifyItem.tax_hope_date_tmp === "") ? null : moment(this.modifyItem.tax_hope_date_tmp).format('YYYY-MM-DD');
                this.modifyItem.amount = this.modifyItem.price - this.modifyItem.dc_price;
                this.modifyItem.key_cnt = 3;

                const { manager_id } = this.$session.get('userInfo');
                this.modifyItem.upt_id = manager_id;
                this.modifyItem.reg_id = manager_id;
                console.log('fnSaveProcess(' + type + ')', this.modifyItem);

                var token = sessionStorage.getItem("myToken");

                var param = encodeURI(JSON.stringify(this.modifyItem));
                var data = new FormData();
                data.append('order', param);

                swal.fire({
                    text: (type === 'modify' ? "수정" : "저장" ) + " 하시겠습니까?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {
                        let url = "";

                        if(type === 'modify'){
                            url = '/api/update/companyOrder?access_token=';
                        }else{
                            url = '/api/insert/insertCompanyUserByAdmin?access_token=';
                        }

                        // 저장 / 수정
                        this.$http.post(url + token, data, null)
                        .then((result) => {
                            const { data } = result;
                            if(data === 'ok'){
                                swal.fire({
                                    type: 'success',
                                    title: (type === 'modify' ? '수정' : '저장' ) + ' 완료 하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                                this.item = {}
                                this.modifyItem = {}

                                this.isModifyLoading = false;
                                this.findCompanyInfo();
                                this.isModify = false;
                            }else{
                                swal.fire({
                                    type: 'error',
                                    title: '수정 중 오류가 발생하였습니다.',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            }
                        });
                        this.isModifyLoading = false;
                    }else{
                        this.isModifyLoading = false;
                    }
                  })
            }
        },
        fnGoList() {
            // 기업회원 관리 목록으로 이동
            history.back();
        }
    },
    computed: {
        sortedPPeriodList() {
          // 배열을 정렬하여 새로운 배열을 반환
          return this.pPeriodList.sort((a, b) => a.item_seq < b.item_seq);
        }
    },
    components: {
        DatePicker,
        cSwitch,
        UserSearchModal,
    },
    mounted() {
        // if(document.querySelectorAll(".tax_area").length === 3){
        // }
    },
}



// WEBPACK FOOTER //
// ./src/views/user/common/userCompany.js